import { styled } from 'styled-components'

export const StyledTitle = styled.div<{
  $index: number,
  $top: string,
}>`
  position: absolute;
  top: ${({ $top }) => $top};
  padding: 0.6em;
  margin: 0.8em 0 0 1.4em;
  overflow: hidden;
  font-size: 1.6em;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.palette.ghostWhite};

  @media (max-width: ${({ theme }) => theme.screens.small}) {
    visibility: ${({ $index }) => (!$index) ? 'hidden' : 'visible'};
    width: 71vw;
    text-align: center;
  }
`
